import type { MouseEvent } from "react";
import { ActionIcon } from "@mantine/core";
import { IconX } from "@tabler/icons-react";

/** Marks control clicks so parent cards do not navigate. */
export const SUGGESTION_CARD_ACTION_ATTR = "data-suggestion-card-action";

type SuggestionDismissButtonProps = {
  onClick: () => void;
};

export default function SuggestionDismissButton({ onClick }: SuggestionDismissButtonProps) {
  const stop = (event: MouseEvent) => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  return (
    <ActionIcon
      type="button"
      variant="outline"
      color="red"
      size={32}
      radius="md"
      aria-label="Remove suggestion"
      title="Remove suggestion"
      data-suggestion-card-action=""
      onPointerDown={stop}
      onMouseDown={stop}
      onClick={(event) => {
        event.preventDefault();
        stop(event);
        onClick();
      }}
      styles={{
        root: {
          border: "1.5px solid #DC2626",
          color: "#DC2626",
          backgroundColor: "#ffffff",
          flexShrink: 0,
        },
      }}
    >
      <IconX size={16} stroke={2.25} />
    </ActionIcon>
  );
}
